import Setting from "./setting";
const PATH = [
  Setting,
  {
    path: "/welcome",
    name: "Welcome",
    redirect: "/print-tags",
    component: () => import("@/views/pages/PrintTags"),
    meta: { requiresAuth: true },
  },
  {
    path: "/print-tags",
    name: "Print",

    component: () => import("@/views/pages/PrintTags"),
    meta: { requiresAuth: true },
  },
  {
    path: "/print-tags-nonserial",
    name: "Print",

    component: () => import("@/views/pages/PrintTagsNonserial"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cover-sheet",
    name: "Print Cover Sheet",

    component: () => import("@/views/pages/CoverSheet"),
    meta: { requiresAuth: true },
  },
];
export default PATH;
